module.exports = __webpack_public_path__ + "img/_schallabsorbierend.09c41cc2.svg";